import { tokens } from "../tokens";

export const cn = {
	[tokens.common.languageChanged]: "语言改变了",
};
